module.exports = __webpack_public_path__ + "static/img/banner_8.4619951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_8.jpg
// module id = zafk
// module chunks = 0